import { fetcher } from "helpers/fetcher";

import {
  TGetFilterManualJobSuggestionReq,
  TGetFilterManualJobSuggestionRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getFilterManualJobSuggestion = async (
  params?: TGetFilterManualJobSuggestionReq
) => {
  return await fetcher<
    TGetFilterManualJobSuggestionRes,
    TGetFilterManualJobSuggestionReq["data"]
  >(ENDPOINT.BU.GET_FILTER_MANUAL_JOB_SUGGESTION, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.BU.GET_FILTER_MANUAL_JOB_SUGGESTION.version,
      [API_HEADER.BU_ID]: params?.idBu,
    },
  });
};

export const queryGetFilterManualJobSuggestion = async (
  params?: TGetFilterManualJobSuggestionReq
) => {
  return (await getFilterManualJobSuggestion(params)).data;
};

queryGetFilterManualJobSuggestion._key = (
  params?: TGetFilterManualJobSuggestionReq,
  key?: string
) => [ENDPOINT.BU.GET_FILTER_MANUAL_JOB_SUGGESTION.url, params, key];
